import styled, { css } from 'styled-components';

const selectedCss = ({ selected }) =>
  selected &&
  css`
    background: var(--grey800);
    color: #fff;
  `;

export default styled.div`
  background: #fff;
  border-radius: 2px;
  display: flex;
  margin-bottom: 4px;
  align-items: stretch;
  height: 36px;
  cursor: pointer;
  ${selectedCss}
`;
